import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { handleNetworkError } from "@repo/ui/libs";
import { useMutation } from "@tanstack/react-query";
import { IExecutiveSignalsPdfResponse } from "./executiveSignals.types";

const useDownloadExecutiveSignalsPdfMutation = () => {
  return useMutation<IExecutiveSignalsPdfResponse>({
    mutationFn: async () =>
      handleGlobalGetRequestQuery({
        url: URLS.EXECUTIVE_SIGNALS_DOWNLOAD,
      }),
    onError: handleNetworkError,
  });
};

export { useDownloadExecutiveSignalsPdfMutation };
